import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { toggle_locked_rotate } from '../../scene';
import toggle_locked_rotate_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/toggle_locked_rotate.svg';
import { img } from '@phi/components';
import ToggleLockedRotateTooltip from './ToggleLockedRotateTooltip';

export const ToggleLockedRotateIcon = toggle_locked_rotate_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return !this.state.loaded;
        },

        alt() {
            return 'Lock rotation within plane, horizontally or vertically';
        },

        coming_soon() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (!this.disabled)
                toggle_locked_rotate();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            active: this.state.rotation_locked,
            selected: this.state.tut_stage === 3,
            id: 'toggle-locked-rotate-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(toggle_locked_rotate_svg, this.alt),
            tooltip: ToggleLockedRotateTooltip,
        });
    }
});
